<ejs-toast #toastRef [position]="position" [target]="'body'" [newestOnTop]="true" [showCloseButton]="true"
    [showProgressBar]="true" [timeOut]="defaultTimeout" [extendedTimeout]="1200" (created)="onToastCreated()"
    cssClass="app-runtime-toast">
</ejs-toast>